import React from 'react';
import { useParams, Link } from 'react-router-dom';
import logo from '../../assets/images/logo-transparent.png';
import authStyles from '../../css/auth/auth.module.css';
import messageStyles from '../../css/auth/message.module.css';

/* Define a type for the message keys */
type MessageType = 'registration-verification' | 'update-email-verification' | 'request-reset-password';

const messages: Record<MessageType, { title: string; message: string }> = {
  'registration-verification': {
    title: 'Verify Your Email',
    message: 'Please check your email to verify your account.',
  },
  'update-email-verification': {
    title: 'Verification Complete',
    message: 'You have updated your email.',
  },
  'request-reset-password': {
    title: 'Password Reset',
    message: 'Please check your email to reset your password.',
  },
};

const Message: React.FC = () => {
  const { type } = useParams<{ type?: string }>();

  const messageContent = type && type in messages ? messages[type as MessageType] : {
    title: 'Unknown Message',
    message: 'The message type is not recognized.',
  };

  return (
    <div className={messageStyles.messageContainer}>
      <div className={messageStyles.messageCard}>
        <img src={logo} alt="Medical Device IQ" className={authStyles.logo} />
        <h1>{messageContent.title}</h1>
        <p>{messageContent.message}</p>
      </div>
      <div className={authStyles.registerLinkOuter}>
      <p>Want to return to the home page? <Link to="/">Click here</Link></p>
      </div>
    </div>
  );
};

export default Message;
